import { render, staticRenderFns } from "./TaskGroup.vue?vue&type=template&id=e36d4cd0"
import script from "./TaskGroup.vue?vue&type=script&lang=js"
export * from "./TaskGroup.vue?vue&type=script&lang=js"
import style0 from "./TaskGroup.vue?vue&type=style&index=0&id=e36d4cd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports